module.exports = __webpack_public_path__ + "img/18_87.498e3caa.png";